var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplefiligreeInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-22d85e7d-3962-4334-a600-5805447ab637",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.23 89.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 44.62,
    cy: 44.62,
    r: 18.75,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 86.23,
    height: 86.23,
    rx: 22.5,
    ry: 22.5,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.99,
    cy: 20.25,
    r: 3.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplefiligreeInstagram);
export default __webpack_public_path__ + "static/media/simple filigree - instagram.47be91d5bd1298db69ec6c4dbc461ad6.svg";
export { ForwardRef as ReactComponent };